jQuery(document).ready(function() {
    const swiper = new Swiper('.swiper-story', {
        slidesPerView: 1,
        centeredSlides: false,    
        grabCursor: true,
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 1
            },
            1024: {
                slidesPerView: 3
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    swiper.init();
});